import { render, staticRenderFns } from "./warehouse-add-material-modal.vue?vue&type=template&id=c1ff36c4"
import script from "./warehouse-add-material-modal.vue?vue&type=script&lang=js"
export * from "./warehouse-add-material-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports